import { render, staticRenderFns } from "./SwiperNext.vue?vue&type=template&id=812d482c&"
import script from "./SwiperNext.vue?vue&type=script&lang=ts&"
export * from "./SwiperNext.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports